import React, { Component } from 'react'
import { RouterView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import { PATH_ZGT, TIAN_GONG_ZGT } from '../constant'
import { Link } from 'react-router'
import { Modal } from 'hljd'
import Api from '@api/jobs'

@observer
export default class extends Component {
  render() {
    return (
      <RouterView
        title="产品介绍"
        header={[<Link to={PATH_ZGT}>智优投</Link>, '产品介绍']}
        bodyStyle={{ padding: 0 }}
        footer={
          <div style={{ position: 'relative' }}>
            <img src="https://qnm.hunliji.com/Fr9IURWvs89TDG7J7Iq_FNd7-kbQ" />

            <img
              src="https://qnm.hunliji.com/FuPczmZ-FxzpqFPmMD-Xa05aPAyC"
              className="center"
              style={{ cursor: 'pointer' }}
              onClick={async () => {
                const { success } = await Api.addCpmJob({
                  job_type: TIAN_GONG_ZGT
                })
                if (success) {
                  Modal.success({
                    title: '申请提交成功',
                    content: '稍后会有专属客户经理与您电话联系'
                  })
                }
              }}
            />
          </div>
        }
      >
        <div className={styles.imgs}>
          <img src="https://qnm.hunliji.com/FhaHjAovt8Ilw0apm2eSHncHXKso" />
          <img src="https://qnm.hunliji.com/FkmN1g-8kJhfGqhMMz_9hmhw8YMZ" />
          <img src="https://qnm.hunliji.com/FtP08H0LOSEvwiBW22p1kqWIU0Oj" />
          <img src="https://qnm.hunliji.com/Flm3rCHnrFxodyUY2M18PzAABh9I" />
          <img src="https://qnm.hunliji.com/Fn-ZK20Uq0NQMTf4M2NFx_Xo281C" />
        </div>
      </RouterView>
    )
  }
}
